import {
  SchemaPartyDetailsResponse,
  SchemaUserDeclaration,
} from '../api/api-schema';
import { CollectionState, ElectionType } from '../api/api-types';
import { DeclarationActionTypes } from '../view-models/DeclarationActionTypes';

export type GuardedDeclarationAction =
  | DeclarationActionTypes.initiate
  | DeclarationActionTypes.confirm
  | DeclarationActionTypes.withdraw;

export const collectionStateByElectionType = (
  partyDetails: SchemaPartyDetailsResponse | undefined,
  electionType: ElectionType | undefined,
): CollectionState | undefined => {
  if (electionType === ElectionType.Folketingsvalg) {
    return partyDetails?.dk?.state as CollectionState | undefined;
  }

  if (electionType === ElectionType.EuropaParlamentsvalg) {
    return partyDetails?.eu?.state as CollectionState | undefined;
  }

  return undefined;
};

const collectionCanReceiveAction = (
  action: GuardedDeclarationAction | undefined,
  declaration: SchemaUserDeclaration | undefined,
  collectionState: CollectionState | undefined,
) => {
  if (collectionState === undefined) return true;

  if (action === DeclarationActionTypes.initiate) {
    return collectionState === CollectionState.running;
  }

  if (action === DeclarationActionTypes.confirm) {
    return collectionState === CollectionState.running;
  }

  if (action === DeclarationActionTypes.withdraw) {
    if (
      collectionState === CollectionState.approved ||
      collectionState === CollectionState.noCollection
    ) {
      return false;
    }

    if (collectionState === CollectionState.locked) {
      return !declaration?.isConfirmed;
    }
  }

  return true;
};

export function getUnavailableActionState(
  action: GuardedDeclarationAction | undefined,
  declaration: SchemaUserDeclaration | undefined,
  collectionState: CollectionState | undefined,
): CollectionState | undefined {
  if (
    collectionState === undefined ||
    collectionCanReceiveAction(action, declaration, collectionState)
  ) {
    return undefined;
  }

  return collectionState;
}
